export default {
  methods: {
    getLang() {
      const storedLang = localStorage.getItem('restorani-lang')
      if (storedLang) {
        this.$i18n.locale = storedLang
      }
    },
    setLang() {
      localStorage.setItem('restorani-lang', this.$i18n.locale)
    }
  }
}

